/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import {
  Button,
  Checkbox,
  Divider,
  Icon,
  Input,
  InputLabel,
  Select,
  Tooltip
} from '@scuf/common';
import { useTranslation } from '@scuf/localization';
import React, { useEffect, useState } from 'react';
import FileUploadActions from '../../../../context/FileUploadContext/FileUploadActions';
import { useFileUploadContext } from '../../../../context/FileUploadContext/FileUploadContext';
import descriptors from '../../../../locales/en-US/descriptors';
import { IAny } from '../../../DashboardKPIWidgets/IEnergyManagementProps';
import { MAGIC_VALUE } from '../../../shared/Utils/Constants';
import {
  addFuelButtonCheck,
  fuelTypeUnitsFilter,
  getMonthDropDown,
  metricTonFun,
  onlyMetricTon,
  unitFilterFun
} from '../../../shared/Utils/Utils';
import {
  addDataList,
  checkDataValid,
  editFuelModal,
  fuelGasTypeLabelCheck,
  getDefaulValue,
  getTempDataDetails,
  getUtilityOptions,
  isAddDataDisabled,
  isDropdownDisabled,
  isEditButtonDisabled,
  isEditOverRideDisabled,
  isFieldDisabledForModalType,
  isFuelDisabled,
  isQuantityDisabled,
  isUnitDropdownDisabled
} from '../AddFuelUtils';
import {
  DropDownWithLoaderContent,
  IAllConnectDetails,
  fuelModalProps
} from './ManualInputConfiguration';
import { getYearValues } from '../../Scope1Table/Scope1TableUtils';
import moment from 'moment';

const ManualInputTabDetailsComponent = (props: DropDownWithLoaderContent) => {
  const d = descriptors.energyManagement;
  const [t, lng] = useTranslation();
  const { setAddFuelDisabled, setUpdateDisabled } = props.details!;
  const { tableData } = props;
  const [state, dispatch] = useFileUploadContext();
  const { isEditButtonEnabled } = state;

  const emptyYearDateQuantity = {
    month: getDefaulValue(
      props.details?.modalType!,
      props.details?.selectedFuelMonthData?.selectedMonth!
    ),
    quantity: getDefaulValue(
      props.details?.modalType!,
      props.details?.selectedFuelMonthData?.selectedQuantity!
    ),
    cost: '',
    monthError: '',
    monthDisable: true,
    noFuelCB: false
  };

  const initDetails = {
    FuelGasType: getDefaulValue(
      props.details?.modalType!,
      props.details?.selectedFuelMonthData?.fuelName!
    ),
    unit: getDefaulValue(
      props.details?.modalType!,
      props.details?.selectedFuelMonthData?.unit!
    ),
    FuelGasTypeError: '',
    unitError: '',
    Co2: getDefaulValue(
      props.details?.modalType!,
      props.details?.selectedFuelMonthData?.Co2!,
      ''
    ),
    regionId: '',
    countryCode: '',
    countryName: '',
    stateCode: '',
    fuelTypeUnitId: '',
    year: getDefaulValue(
      props.details?.modalType!,
      props.details?.selectedFuelMonthData?.selectedYear!
    ),

    details: [emptyYearDateQuantity],
    emissionFactorId: '',
    fuelTypeId: '',
    overRideFlag: false
  };

  const init: IAny[] | (() => IAny[]) = [];
  const dateDetails = ['month'];
  const [allDetails, setAllDetails] = useState<IAllConnectDetails>(
    initDetails as any
  );
  const [utilityOptions, setutilityOptions] = useState(init);
  const [disableUnit, setDisableUnit] = useState(false);
  const [disableYear, setDisableYear] = useState(true);
  const [unit, setunit] = useState(init);
  const [yearSelection, setYearSelection] = useState('');

  const [scopeTwo, setscopeTwo] = useState(false);
  useEffect(() => {
    let categoryName = fuelGasTypeLabelCheck(
      props.activeIndexDataUpload,
      'stationaryCombustion',
      'refrigerants',
      props.toggleFeatureAllUpload,
      props.toggleFeatureScopeOne,
      props.toggleFeatureScopeTwo,
      'scope2',
      props.toggleFeatureGAS,
      'GAS'
    );
    if (['GAS', 'scope2'].includes(categoryName as any)) {
      setscopeTwo(true);
    } else {
      setscopeTwo(false);
    }
  }, [props]);
  useEffect(() => {
    let categoryName = fuelGasTypeLabelCheck(
      props.activeIndexDataUpload,
      'stationaryCombustion',
      'refrigerants',
      props.toggleFeatureAllUpload,
      props.toggleFeatureScopeOne,
      props.toggleFeatureScopeTwo,
      'scope2',
      props.toggleFeatureGAS,
      'GAS'
    );
    const utilityOptions = getUtilityOptions(
      isFieldDisabled,
      allDetails,
      setunit,
      setYearSelection,
      props,
      categoryName
    );
    setutilityOptions(utilityOptions!);
  }, []);

  useEffect(() => {
    let categoryName = fuelGasTypeLabelCheck(
      props.activeIndexDataUpload,
      'stationaryCombustion',
      'refrigerants',
      props.toggleFeatureAllUpload,
      props.toggleFeatureScopeOne,
      props.toggleFeatureScopeTwo,
      'scope2',
      props.toggleFeatureGAS,
      'GAS'
    );
    const Check = ['scope2', 'GAS'];
    if (
      utilityOptions.length === 1 &&
      tableData !== undefined &&
      Check.includes(categoryName as any)
    ) {
      let checkingforScope2 = Check.includes(categoryName as any);
      let unit = unitFilterFun(
        props.data!,
        utilityOptions[0].value as any,
        checkingforScope2
      )[0].fuelTypeUnits?.map((unitValue: { unit: IAny }) => {
        return {
          text: unitValue?.unit,
          value: unitValue?.unit
        };
      });
      let fuelId = unitFilterFun(
        props.data!,
        utilityOptions[0].value as string,
        checkingforScope2
      )[0].fuelType?.fuelTypeId;
      //should remove this condition and add unit directly to asetunit() once we get all the unit for Refrigerants
      const metricTon = metricTonFun(
        props.details?.activeIndexDataUpload,
        unit,
        tableData,
        utilityOptions[0].value,
        props.details?.toggleFeatureAllUpload,
        props.details?.toggleFeatureScopeOne,
        props.details?.toggleFeatureGAS,
        props.details?.toggleFeatureScopeTwo
      );
      const filterdVal = tableData.find(
        (filterVal: { fuelName: string }) =>
          filterVal.fuelName === utilityOptions[0].value
      )?.unit;
      if (filterdVal) {
        setDisableUnit(true);
      } else {
        setDisableUnit(false);
      }
      setunit(metricTon);
      const detailsUpdatedVal = allDetails.details.map((val) => {
        return {
          ...val,
          month: '',
          quantity: '',
          monthError: '',
          noFuelCB: false
        };
      });
      setDisableYear(false);
      setAllDetails({
        ...allDetails,
        FuelGasType: utilityOptions[0].value,
        unit: filterdVal ? filterdVal : '',
        Co2: '',
        regionId: '',
        countryCode: '',
        countryName: '',
        fuelTypeUnitId: '',
        stateCode: '',
        emissionFactorId: '',
        fuelTypeId: fuelId,
        details: detailsUpdatedVal
      });
    }
  }, [utilityOptions]);
  useEffect(() => {
    let categoryName = fuelGasTypeLabelCheck(
      props.activeIndexDataUpload,
      'stationaryCombustion',
      'refrigerants',
      props.toggleFeatureAllUpload,
      props.toggleFeatureScopeOne,
      props.toggleFeatureScopeTwo,
      'scope2',
      props.toggleFeatureGAS,
      'GAS'
    );
    const Check = ['scope2', 'GAS'];
    if (unit.length === 1 && Check.includes(categoryName as any)) {
      let fuelId = fuelTypeUnitsFilter(
        props.data!,
        unit[0].value as any,
        allDetails?.FuelGasType
      )[0]?.fuelTypeUnitId;
      setAllDetails({
        ...allDetails,
        unit: unit[0].value,
        fuelTypeUnitId: fuelId
      });
    }
  }, [unit]);
  useEffect(() => {
    let checkDetails = addFuelButtonCheck(allDetails, scopeTwo);
    if (checkDataValid(allDetails, checkDetails)) {
      setUpdateDisabled(true);
    } else {
      dispatch(FileUploadActions.saveUpdatedPayload(allDetails));
      setUpdateDisabled(false);
    }
  }, [allDetails, scopeTwo]);

  const removeDataList = (key: number) => {
    let tempDataDetails = [...allDetails.details];
    tempDataDetails.splice(key, 1);
    setAllDetails({
      ...allDetails,
      details: tempDataDetails
    });
  };

  const defaultRegionID = (emissionFactorDetails: any[]) => {
    let defaultRegionIdList = emissionFactorDetails?.filter(
      (regionIDSelection: { regionId: any }) => regionIDSelection?.regionId
    );
    let defaultRegionId =
      defaultRegionIdList && defaultRegionIdList[0]?.regionId;
    return defaultRegionId;
  };

  const defaultCountryDetails = (emissionFactorDetails: any[]) => {
    let defaultRegionIdList = emissionFactorDetails?.filter(
      (CountryDetailsSelection: {
        countryName: any;
        countryCode: any;
        regionId: any;
      }) =>
        CountryDetailsSelection?.countryCode &&
        CountryDetailsSelection?.countryName
    );
    return {
      countryCodeDefault:
        defaultRegionIdList && defaultRegionIdList[0]?.countryCode,
      countryNameDefault:
        defaultRegionIdList && defaultRegionIdList[0]?.countryName
    };
  };

  const emissionFactorValue = (
    emissionFactorDetails: any,
    year: any,
    details: fuelModalProps | undefined,
    fuelTypeUnitId: any
  ) => {
    if (!['missingData', 'editFuelData'].includes(details?.modalType as any)) {
      const GuidEmpty = '00000000-0000-0000-0000-000000000000';
      let emissionFactorDetailsObject, defaultRegionId, defaultCountryDetail;
      if (scopeTwo) {
        emissionFactorDetailsObject = emissionFactorDetails.filter(
          (val: {
            siteId: string;
            effectiveFrom: moment.MomentInput;
            fuelTypeUnitId: string;
          }) =>
            val.siteId !== GuidEmpty &&
            moment(val.effectiveFrom).year() === parseInt(year) &&
            val.fuelTypeUnitId === fuelTypeUnitId
        );
        defaultRegionId = defaultRegionID(emissionFactorDetails);
        defaultCountryDetail = defaultCountryDetails(emissionFactorDetails);
      } else {
        emissionFactorDetailsObject = emissionFactorDetails.filter(
          (val: {
            siteId: string;
            effectiveFrom: moment.MomentInput;
            fuelTypeUnitId: string;
          }) =>
            val.siteId !== GuidEmpty &&
            moment(val.effectiveFrom).year() === parseInt(year)
        );
      }

      let emissionFactorVal,
        emissionFactorId,
        regionId,
        countryCode,
        countryName,
        stateCode;
      if (emissionFactorDetailsObject.length > 0) {
        emissionFactorVal = emissionFactorDetailsObject[0].emissionFactorValue;
        emissionFactorId = emissionFactorDetailsObject[0].emissionFactorId;
        regionId = emissionFactorDetailsObject[0].regionId
          ? emissionFactorDetailsObject[0].regionId
          : scopeTwo
          ? defaultRegionId
          : '';
        countryCode =
          emissionFactorDetailsObject &&
          emissionFactorDetailsObject[0].countryCode
            ? emissionFactorDetailsObject[0]?.countryCode
            : scopeTwo
            ? defaultCountryDetail?.countryCodeDefault
            : '';
        countryName =
          emissionFactorDetailsObject &&
          emissionFactorDetailsObject[0]?.countryName
            ? emissionFactorDetailsObject[0]?.countryName
            : scopeTwo
            ? defaultCountryDetail?.countryNameDefault
            : 'N/A';
        stateCode = emissionFactorDetailsObject[0].stateCode;
      } else {
        let emissionFactorDetailsObjectDefault;
        if (scopeTwo) {
          let emissionFactorDetailsDefaultWithregionId = emissionFactorDetails.filter(
            (val: {
              regionId: boolean;
              siteId: string;
              effectiveFrom: moment.MomentInput;
              fuelTypeUnitId: string;
            }) =>
              val?.siteId === GuidEmpty &&
              val?.fuelTypeUnitId === fuelTypeUnitId &&
              val?.regionId
          );
          if (emissionFactorDetailsDefaultWithregionId?.length > 0) {
            emissionFactorDetailsObjectDefault =
              emissionFactorDetailsDefaultWithregionId[0];
          } else {
            let emissionFactorDetailsDefaultWithoutregionId = emissionFactorDetails?.filter(
              (val: {
                fuelTypeUnitId: any;
                regionId: boolean;
                siteId: string;
                effectiveFrom: moment.MomentInput;
              }) =>
                val?.siteId === GuidEmpty &&
                val?.fuelTypeUnitId === fuelTypeUnitId &&
                !val?.regionId
            )[0];
            emissionFactorDetailsObjectDefault = emissionFactorDetailsDefaultWithoutregionId;
          }
          defaultRegionId = defaultRegionID(emissionFactorDetails);
          defaultCountryDetail = defaultCountryDetails(emissionFactorDetails);
        } else {
          emissionFactorDetailsObjectDefault = emissionFactorDetails.filter(
            (val: {
              siteId: string;
              effectiveFrom: moment.MomentInput;
              fuelTypeUnitId: string;
            }) => val.siteId === GuidEmpty
          )[0];
        }
        emissionFactorVal =
          emissionFactorDetailsObjectDefault?.emissionFactorValue;
        emissionFactorId = emissionFactorDetailsObjectDefault?.emissionFactorId;
        regionId = emissionFactorDetailsObjectDefault?.regionId
          ? emissionFactorDetailsObjectDefault?.regionId
          : scopeTwo
          ? defaultRegionId
          : '';
        countryCode = emissionFactorDetailsObjectDefault?.countryCode
          ? emissionFactorDetailsObjectDefault?.countryCode
          : scopeTwo
          ? defaultCountryDetail?.countryCodeDefault
          : '';
        countryName = emissionFactorDetailsObjectDefault?.countryName
          ? emissionFactorDetailsObjectDefault?.countryName
          : scopeTwo
          ? defaultCountryDetail?.countryNameDefault
          : 'N/A';
        stateCode = emissionFactorDetailsObjectDefault?.stateCode;
      }
      return {
        emissionFactorVal,
        emissionFactorId,
        regionId,
        countryCode,
        countryName,
        stateCode
      };
    } else {
      return {
        emissionFactorVal: allDetails.Co2,
        emissionFactorId: allDetails.emissionFactorId,
        regionId: allDetails.regionId,
        countryCode: allDetails.countryCode,
        stateCode: allDetails.stateCode
      };
    }
  };
  const emissionFactorvalues = (
    data: any[],
    FuelGasType: string,
    year: any,
    details: fuelModalProps | undefined,
    fuelTypeUnitId: any
  ) => {
    let categoryName = fuelGasTypeLabelCheck(
      props.activeIndexDataUpload,
      'stationaryCombustion',
      'refrigerants',
      props.toggleFeatureAllUpload,
      props.toggleFeatureScopeOne,
      props.toggleFeatureScopeTwo,
      'scope2',
      props.toggleFeatureGAS,
      'GAS'
    );
    const Check = ['scope2', 'GAS'];
    let checkingforScope2 = Check.includes(categoryName as any);
    let emissionFactorDetails = unitFilterFun(
      data,
      FuelGasType,
      checkingforScope2
    )[0].emissionFactor;
    return emissionFactorValue(
      emissionFactorDetails,
      year,
      details,
      fuelTypeUnitId
    );
  };
  const changeFuelGasType = (value: any, key: string) => {
    if (key === 'FuelGasType') {
      let categoryNameCheck = fuelGasTypeLabelCheck(
        props.activeIndexDataUpload,
        'stationaryCombustion',
        'refrigerants',
        props.toggleFeatureAllUpload,
        props.toggleFeatureScopeOne,
        props.toggleFeatureScopeTwo,
        'scope2',
        props.toggleFeatureGAS,
        'GAS'
      );
      const Check = ['scope2', 'GAS'];
      let checkingforScope2 = Check.includes(categoryNameCheck as any);
      let unit = unitFilterFun(
        props.data!,
        value as any,
        checkingforScope2
      )[0].fuelTypeUnits?.map((unitValue: { unit: IAny }) => {
        return {
          text: unitValue?.unit,
          value: unitValue?.unit
        };
      });
      let fuelId = unitFilterFun(
        props.data!,
        value as string,
        checkingforScope2
      )[0].fuelType?.fuelTypeId;

      //should remove this condition and add unit directly to asetunit() once we get all the unit for Refrigerants
      const metricTon = metricTonFun(
        props.details?.activeIndexDataUpload,
        unit,
        tableData,
        value,
        props.details?.toggleFeatureAllUpload,
        props.details?.toggleFeatureScopeOne,
        props.details?.toggleFeatureGAS,
        props.details?.toggleFeatureScopeTwo
      );
      const filterdVal = tableData.find(
        (filterVal: { fuelName: string }) => filterVal.fuelName === value
      )?.unit;
      if (filterdVal) {
        setDisableUnit(true);
      } else {
        setDisableUnit(false);
      }
      setunit(metricTon);
      const detailsUpdatedVal = allDetails.details.map((val) => {
        return {
          ...val,
          month: '',
          quantity: '',
          monthError: '',
          noFuelCB: false
        };
      });
      setDisableYear(false);
      let categoryName = fuelGasTypeLabelCheck(
        props.activeIndexDataUpload,
        'stationaryCombustion',
        'refrigerants',
        props.toggleFeatureAllUpload,
        props.toggleFeatureScopeOne,
        props.toggleFeatureScopeTwo,
        'scope2',
        props.toggleFeatureGAS,
        'GAS'
      );
      setAllDetails({
        ...allDetails,
        [key as string]: value,
        unit:
          categoryName === 'refrigerants'
            ? 'metric ton'
            : filterdVal
            ? filterdVal
            : '',
        Co2: '',
        regionId: '',
        countryCode: '',
        countryName: '',
        fuelTypeUnitId: '',
        stateCode: '',
        emissionFactorId: '',
        fuelTypeId: fuelId,
        details: detailsUpdatedVal
      });
    } else if (key === 'year') {
      let emissionFactor: any = {};
      if (
        !['missingData', 'editFuelData'].includes(
          props.details?.modalType as any
        )
      ) {
        emissionFactor = emissionFactorvalues(
          props.data!,
          allDetails.FuelGasType,
          value,
          props.details,
          allDetails.fuelTypeUnitId
        );
      }
      const detailsUpdatedVal = allDetails.details.map((val) => {
        return {
          ...val,
          month: '',
          quantity: '',
          monthError: '',
          monthDisable: false,
          noFuelCB: false
        };
      });
      setAllDetails({
        ...allDetails,
        [key as any]: value,
        Co2: ['missingData', 'editFuelData'].includes(
          props.details?.modalType as any
        )
          ? allDetails.Co2
          : emissionFactor.emissionFactorVal,
        emissionFactorId: ['missingData', 'editFuelData'].includes(
          props.details?.modalType as any
        )
          ? allDetails.emissionFactorId
          : emissionFactor.emissionFactorId,
        regionId: emissionFactor.regionId,
        countryCode: emissionFactor.countryCode,
        countryName: emissionFactor?.countryName
          ? emissionFactor?.countryName
          : 'N/A',
        stateCode: emissionFactor.stateCode,
        details: detailsUpdatedVal
      });
    } else if (key === 'Co2') {
      const re = /^[0-9]*\.?[0-9]*$/;
      if (value === '' || re.test(value as any)) {
        if (value.length <= MAGIC_VALUE.NINE || value.toString() === '') {
          setAllDetails({ ...allDetails, [key as any]: value });
        }
      }
    } else if (key === 'overRideFlag') {
      let emissionFactor: any = {};
      if (
        !['missingData', 'editFuelData'].includes(
          props.details?.modalType as any
        )
      ) {
        emissionFactor = emissionFactorvalues(
          props.data!,
          allDetails.FuelGasType,
          allDetails.year,
          props.details,
          allDetails.fuelTypeUnitId
        );
      }
      if (allDetails.overRideFlag) {
        setAllDetails({
          ...allDetails,
          [key]: value,
          Co2: ['missingData', 'editFuelData'].includes(
            props.details?.modalType as any
          )
            ? allDetails.Co2
            : emissionFactor.emissionFactorVal,
          emissionFactorId: ['missingData', 'editFuelData'].includes(
            props.details?.modalType as any
          )
            ? allDetails.emissionFactorId
            : emissionFactor.emissionFactorId
        });
      } else {
        setAllDetails({ ...allDetails, [key]: value });
      }
    } else if (key === 'unit') {
      let fuelId = fuelTypeUnitsFilter(
        props.data!,
        value as any,
        allDetails?.FuelGasType
      )[0]?.fuelTypeUnitId;
      if (scopeTwo && allDetails.year !== '') {
        let emissionFactor = emissionFactorvalues(
          props.data!,
          allDetails.FuelGasType,
          allDetails.year,
          props.details,
          fuelId
        );
        setAllDetails({
          ...allDetails,
          [key as any]: value,
          fuelTypeUnitId: fuelId,
          Co2: emissionFactor.emissionFactorVal,
          emissionFactorId: emissionFactor.emissionFactorId,
          regionId: emissionFactor.regionId,
          countryCode: emissionFactor.countryCode,
          countryName: emissionFactor?.countryName
            ? emissionFactor?.countryName
            : 'N/A',
          stateCode: emissionFactor.stateCode
        });
      } else {
        setAllDetails({
          ...allDetails,
          [key as any]: value,
          fuelTypeUnitId: fuelId
        });
      }
    } else {
      setAllDetails({ ...allDetails, [key]: value });
    }
  };

  let changeYearMonthType = (index: number, value: string, name: string) => {
    const tempDataDetails = getTempDataDetails(
      index,
      value,
      name,
      allDetails,
      t
    );
    setAllDetails({
      ...allDetails,
      details: tempDataDetails
    });
  };

  let changeNofuelValue = (index: number, checked: boolean) => {
    let tempDataDetails = [...allDetails.details];
    checked === true
      ? (tempDataDetails[index].quantity = '0')
      : (tempDataDetails[index].quantity = '');
    tempDataDetails[index].noFuelCB = checked;
    setAllDetails({
      ...allDetails,
      details: tempDataDetails
    });
  };

  useEffect(() => {
    if (
      props.details?.modalType === 'missingData' ||
      props.details?.modalType === 'editFuelData'
    ) {
      setAddFuelDisabled(isFuelDisabled(allDetails));
    }
  }, [allDetails]);

  const isFieldDisabled = isFieldDisabledForModalType(
    props.details?.modalType!
  );
  const isEditFuelModal = editFuelModal(props.details?.modalType);

  const disableEditButton = () => {
    dispatch(FileUploadActions.disableEdit());
  };

  return (
    <>
      {isEditFuelModal && (
        <div className="fuel-modal-edit">
          <div>
            <Button
              type="link"
              disabled={!isEditButtonEnabled}
              onClick={() => disableEditButton()}
              content={t(d.EDIT)}
              style={{ float: 'right' }}
            />
          </div>
          <Divider />{' '}
        </div>
      )}
      <div
        className={
          scopeTwo
            ? 'manualInputDetails  justifyDetailsCOTwoScope2'
            : 'manualInputDetails  justifyDetailsCOTwo'
        }
      >
        <div>
          <InputLabel
            className="fuelGasType-label"
            label={t(d.SelectCategory)}
          />
          <Select
            className="fuelGasType"
            placeholder={
              fuelGasTypeLabelCheck(
                props.activeIndexDataUpload,
                t(d.StationaryCombustion),
                t(d.REFRIGERANTS),
                props.toggleFeatureAllUpload,
                props.toggleFeatureScopeOne,
                props.toggleFeatureScopeTwo,
                t(d.SCOPE2),
                props.toggleFeatureGAS,
                t(d.METEREDGAS)
              ) as any
            }
            options={utilityOptions}
            //value={allDetails.FuelGasType}
            onChange={(value) => {
              changeFuelGasType(value, 'FuelGasType');
            }}
            error={allDetails.FuelGasTypeError}
            disabled={true}
          />
        </div>
      </div>

      <div
        className={
          '!scopeTwo ? manualInputDetails justifyDetailsFirst : scope2align '
        }
      >
        <div className={'fuelType'}>
          <InputLabel
            className="fuelGasType-label"
            label={
              fuelGasTypeLabelCheck(
                props.activeIndexDataUpload,
                t(d.FUELGASTYPE),
                t(d.COMPOUNDTYPE),
                props.toggleFeatureAllUpload,
                props.toggleFeatureScopeOne,
                props.toggleFeatureScopeTwo,
                t(d.UTILITYTYPE),
                props.toggleFeatureGAS,
                t(d.UTILITYTYPE)
              ) as any
            }
          />
          <Select
            className="fuelGasType"
            placeholder={
              utilityOptions?.length === 1
                ? utilityOptions[0].text
                : fuelGasTypeLabelCheck(
                    props.activeIndexDataUpload,
                    t(d.FUELGASTYPESELECT),
                    t(d.COMPOUNDSELECT),
                    props.toggleFeatureAllUpload,
                    props.toggleFeatureScopeOne,
                    props.toggleFeatureScopeTwo,
                    t(d.UTILITYSELECT),
                    props.toggleFeatureGAS,
                    t(d.UTILITYTYPE)
                  )
            }
            options={utilityOptions}
            value={allDetails.FuelGasType}
            onChange={(value) => {
              changeFuelGasType(value, 'FuelGasType');
            }}
            error={allDetails.FuelGasTypeError}
            disabled={utilityOptions?.length === 1 ? true : isFieldDisabled}
          />
        </div>
        <div className="fuelType">
          <InputLabel className="fuelGasType-label" label={t(d.UNIT)} />
          <Select
            className="unitType"
            placeholder={unit?.length === 1 ? unit[0].text : t(d.UNITSELECT)}
            options={unit}
            value={allDetails.unit}
            onChange={(value) => {
              changeFuelGasType(value, 'unit');
            }}
            error={allDetails.FuelGasTypeError}
            disabled={
              unit?.length === 1
                ? true
                : disableUnit ||
                  isUnitDropdownDisabled(isFieldDisabled, allDetails)
            }
          />
        </div>
        {!scopeTwo ? (
          <div className={'fuelType'}>
            <InputLabel className="fuelGasType-label" label={t(d.YEAR)} />
            <Select
              className="unitType"
              placeholder={t(d.YEARSELECT)}
              options={getYearValues()}
              value={allDetails.year}
              onChange={(val) => {
                changeFuelGasType(val, 'year');
              }}
              disabled={isFieldDisabled || disableYear}
            />
          </div>
        ) : null}
      </div>
      {scopeTwo ? (
        <div
          className={
            'manualInputDetails manualInputDetailsPaddingZero justifyDetailsFirst scope2alignChange'
          }
        >
          <div className="fuelType">
            <InputLabel className="fuelGasType-label" label={t(d.YEAR)} />
            <Select
              className="unitType"
              placeholder={t(d.YEARSELECT)}
              options={getYearValues()}
              value={allDetails.year}
              onChange={(val) => {
                changeFuelGasType(val, 'year');
              }}
              disabled={isFieldDisabled || disableYear}
            />
          </div>
          <div className="fuelType">
            <InputLabel className="fuelGasType-label" label={t(d.Country)} />
            <Input
              className="Country"
              placeholder={t(d.Country)}
              value={allDetails.countryName}
              disabled={true}
            />
          </div>
          {/* <div className="fuelType">
            <InputLabel className="fuelGasType-label" label={t(d.State)} />
            <Input
              className="Country"
              placeholder={t(d.State)}
              value={allDetails.stateCode?.toUpperCase()}
              disabled={true}
            />
          </div> */}
        </div>
      ) : null}

      <div className="manualInputDetails justifyDetailsCOTwo">
        <div>
          <div className="displayFlexCO2Emission">
            <InputLabel
              className="fuelGasType-label"
              label={t(d.EMISSIONFACTOR)}
            />
            <Tooltip
              element={
                <img
                  className="InfoIcon-img"
                  src={require('../../../../images/InfoIcon.svg')}
                />
              }
              event="hover"
              className="fuelGasType-label-ToolTip"
              header={t(d.CO2FACTORROOLTIPHEADER)}
              content={
                fuelGasTypeLabelCheck(
                  props.activeIndexDataUpload,
                  t(d.CO2FACTORSCCONTENT),
                  t(d.CO2FACTORRFCONTENT),
                  props.toggleFeatureAllUpload,
                  props.toggleFeatureScopeOne,
                  props.toggleFeatureScopeTwo,
                  t(d.CO2FACTORSCOPETWOANDGASCONTENT),
                  props.toggleFeatureGAS,
                  t(d.CO2FACTORSCOPETWOANDGASCONTENT)
                ) as any
              }
              position="right center"
              size="small"
            />
          </div>
          <Input
            className="co2EmissionFactor"
            type="text"
            placeholder=""
            value={allDetails.Co2}
            onChange={(checked) => {
              changeFuelGasType(checked, 'Co2');
            }}
            //label={t(d.EMISSIONFACTOR)}
            disabled={!allDetails.overRideFlag}
          />
        </div>
      </div>
      <Checkbox
        className="overrideCheckbox"
        label={t(d.Override)}
        checked={allDetails.overRideFlag}
        onChange={(checked) => {
          changeFuelGasType(checked, 'overRideFlag');
        }}
        disabled={isEditOverRideDisabled(
          isEditButtonEnabled,
          isEditFuelModal,
          allDetails
        )}
      />
      {allDetails.overRideFlag ? (
        <div className="overRideMessage">
          <p>
            <span className="overRideTitle">{t(d.PLEASENOTE)}</span>
            <span className="overRideText">{t(d.PLEASENOTETEXT)}</span>
          </p>
        </div>
      ) : null}
      {!scopeTwo ? (
        <>
          <Divider />
          {allDetails.details.map((data, key) => {
            return (
              <React.Fragment key={`account-${key}`}>
                <div className="account-relative">
                  {key > 0 && (
                    <Button
                      className="DeleteData-img"
                      onClick={() => removeDataList(key)}
                      type="link"
                      icon={
                        <img
                          src={require('../../../../images/DeleteData.svg')}
                        />
                      }
                      content=""
                    />
                  )}
                  <div className="manualInputDetails justifyDetailsSecond">
                    <div className="yearmanual">
                      <InputLabel
                        className="fuelGasType-label"
                        label={t(d.MONTH)}
                      />
                      <Select
                        className="unitType"
                        placeholder={t(d.MONTHSELECT)}
                        options={getMonthDropDown(allDetails.year, lng)}
                        value={data.month}
                        onChange={(val) => {
                          changeYearMonthType(key, val, 'month');
                        }}
                        error={data.monthError}
                        disabled={isDropdownDisabled(
                          'month',
                          isFieldDisabled,
                          data.monthDisable
                        )}
                      />
                    </div>
                    <div className="yearmanual">
                      <Input
                        className="co2EmissionFactor"
                        type="text"
                        placeholder={t(d.QUANTITYENTER)}
                        onChange={(value) => {
                          changeYearMonthType(key, value, 'co2EmissionFactor');
                        }}
                        value={data.quantity}
                        label={t(d.QUANTITY)}
                        disabled={isQuantityDisabled(
                          data.noFuelCB,
                          isEditFuelModal,
                          isEditButtonEnabled
                        )}
                      />
                    </div>

                    <div className="yearmanual">
                      {/* this will needed in next sprint, dont remove */}

                      {/* <Input
                  className="co2EmissionFactor"
                  type="text"
                  placeholder={t(d.COSTENTER)}
                  onChange={(value) => {
                    changeYearMonthType(key, value, 'cost');
                  }}
                  value={data.cost as any}
                  label={t(d.COSTSCOPE)}
                  disabled={isQuantityDisabled(
                    data.noFuelCB,
                    isEditFuelModal,
                    isEditButtonEnabled
                  )}
                /> */}
                    </div>
                  </div>
                  <Checkbox
                    className="noFuelCheckbox"
                    label={fuelGasTypeLabelCheck(
                      props.activeIndexDataUpload,
                      t(d.NOFUELCONSUMED),
                      t(d.NOCONSUMED),
                      props.toggleFeatureAllUpload,
                      props.toggleFeatureScopeOne,
                      props.toggleFeatureScopeTwo,
                      '',
                      props.toggleFeatureGAS,
                      ''
                    )}
                    checked={data.noFuelCB}
                    onChange={(checked) => {
                      changeNofuelValue(key, checked);
                    }}
                    disabled={isEditButtonDisabled(
                      isEditButtonEnabled,
                      isEditFuelModal
                    )}
                  />
                </div>
              </React.Fragment>
            );
          })}
          {!isFieldDisabled && (
            <div className="add-data-button">
              <Button
                className="add-data"
                type="link"
                icon={<Icon name="badge-plus" root="common" />}
                onClick={() => {
                  addDataList(allDetails, setAllDetails, emptyYearDateQuantity);
                }}
                disabled={isAddDataDisabled(allDetails)}
              >
                {t(d.ADDDATA)}
              </Button>
            </div>
          )}
        </>
      ) : null}
    </>
  );
};

export default ManualInputTabDetailsComponent;
